import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { useWindowSize } from '@/hooks/useWindowSize';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { Button, MyLink } from '@scramble/ui';
import { prettyFloatMoney, prettyMoney } from '@/helpers/utils';
import { useGetHappyBrands } from '@/query/queries/dashboard/useGetHappyBrands';
import { Image } from '@/components/Image';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

const id = MODAL_IDS.happy_brands;

export const HappyBrandsModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

const Modal = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const { isMobile } = useWindowSize();
  const { data } = useGetHappyBrands();

  const content = (
    <div className={s.modal}>
      <div className={s.header}>
        <div className={s.title}>
          {t('dashboard:happy_brands_modal.brands_helped')}
        </div>
      </div>
      <div className={s.content}>
        <div className={s.content_inner}>
          <div className={s.list}>
            {data?.founders.map(brand => (
              <MyLink
                href={APP_LINKS.startupDetail(brand.slug_company)}
                key={brand.id}
                className={classnames(s.card, 'hov')}
              >
                <div className={s.card_icon}>
                  <Image
                    image={brand.url_logo}
                    preset="companyLogoCompact"
                    sizes="24px"
                    alt={brand.url_logo?.name}
                    width={24}
                    height={24}
                  />
                </div>
                <div className={s.card_content}>{brand.company}</div>
                <div className={s.card_amount}>
                  {brand.invested_in_brand < 1
                    ? prettyFloatMoney(brand.invested_in_brand)
                    : prettyMoney(brand.invested_in_brand)}
                </div>
              </MyLink>
            ))}
          </div>
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          label={t('dashboard:happy_brands_modal.got_it')}
          onClick={() => closeModal(id)}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
